module.exports = __webpack_public_path__ + "static/img/cont35 (5).dbcee08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont35 (5).jpg
// module id = iy/F
// module chunks = 0